import type { Coordinate2d } from "."
import { toRadians } from "./toRadians"

const coordsToRadians = (coords: Coordinate2d): Coordinate2d => {
  return { lat: toRadians(coords.lat), lng: toRadians(coords.lng) }
}

const toDegrees = (radians: number) => {
  return (radians * 180) / Math.PI
}

export const findBearingBetweenTwoPoints = (
  coords1: Coordinate2d,
  coords2: Coordinate2d,
): number => {
  const startCoords = coordsToRadians(coords1)
  const destCoords = coordsToRadians(coords2)

  const y = Math.sin(destCoords.lng - startCoords.lng) * Math.cos(destCoords.lat)
  const x =
    Math.cos(startCoords.lat) * Math.sin(destCoords.lat) -
    Math.sin(startCoords.lat) *
      Math.cos(destCoords.lat) *
      Math.cos(destCoords.lng - startCoords.lng)

  const bearing = Math.atan2(y, x)
  const bearingInDegrees = toDegrees(bearing)

  return (bearingInDegrees + 360) % 360
}
